import React, { createContext, useContext, useEffect, useState } from "react";

const translations = {
  es: {
    app_name: "Pollagol 2026",
    tagline: "Pronostica. Compite. Gana.",
    subtagline: "El mundial 2026 se juega aquí.",
    nav_matches: "Partidos",
    nav_leaderboard: "Clasificación",
    nav_prizes: "Premios",
    nav_logs: "Movimientos",
    nav_admin: "Admin",
    login: "Iniciar sesión",
    register: "Registrarse",
    logout: "Cerrar sesión",
    email: "Correo electrónico",
    password: "Contraseña",
    name: "Nombre",
    username: "Usuario",
    submit: "Enviar",
    your_points: "Tus puntos",
    your_rank: "Tu posición",
    predict: "Pronosticar",
    save_prediction: "Guardar pronóstico",
    prediction_locked: "Cerrado",
    match_finished: "Finalizado",
    match_scheduled: "Programado",
    live: "En vivo",
    home: "Local",
    away: "Visitante",
    stage: "Etapa",
    venue: "Estadio",
    kickoff: "Inicio",
    exact_score: "Marcador exacto",
    correct_outcome: "Resultado correcto",
    points_rule: "+5 pts marcador exacto · +2 pts resultado",
    rank: "Pos",
    player: "Jugador",
    points: "Pts",
    no_matches: "Sin partidos aún.",
    no_predictions: "Aún no has hecho pronósticos.",
    no_logs: "Sin movimientos registrados.",
    all_logs: "Todos los movimientos",
    my_logs: "Mis movimientos",
    time: "Hora",
    action: "Acción",
    details: "Detalle",
    prizes_title: "Premios del torneo",
    prizes_subtitle: "Lo que te llevas si dominas el Mundial",
    first_place: "1er lugar",
    second_place: "2do lugar",
    third_place: "3er lugar",
    admin_panel: "Panel Admin",
    add_match: "Agregar partido",
    add_prize: "Agregar premio",
    set_result: "Establecer resultado",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    title: "Título",
    description: "Descripción",
    position: "Posición",
    image_url: "URL de imagen",
    home_team: "Equipo local",
    away_team: "Equipo visitante",
    home_flag: "Bandera local",
    away_flag: "Bandera visitante",
    welcome_back: "Bienvenido de vuelta",
    create_account: "Crea tu cuenta",
    dont_have_account: "¿No tienes cuenta?",
    have_account: "¿Ya tienes cuenta?",
    get_started: "Empezar",
    view_matches: "Ver partidos",
    total_players: "Jugadores",
    total_matches: "Partidos",
    hero_cta: "Únete al torneo",
    feature_predict: "Pronostica cada marcador del Mundial 2026",
    feature_compete: "Compite en la clasificación global",
    feature_win: "Gana premios configurados por el admin",
    filter_all: "Todos",
    filter_live: "En vivo",
    filter_upcoming: "Próximos",
    filter_finished: "Finalizados",
    filter_by_group: "Filtrar por grupo",
    all_groups: "Todos los grupos",
    play_the: "JUEGA EL",
    world_cup: "MUNDIAL.",
    own_the_slip: "GANA LA POLLA.",
    open_pool: "Polla abierta",
    standings: "Tabla de posiciones",
    live_board: "TABLA EN VIVO",
    payout_structure: "ESQUEMA DE PREMIOS",
    win_the: "GANA EL",
    trophy: "TROFEO",
    your_slip: "Tu boleta",
    pick: "Pronóstico",
    balance: "Saldo",
    bal_short: "SAL",
    matches_short: "Partidos",
    players_short: "Jugadores",
    groups_short: "Grupos",
    group_stage_fixtures: "Partidos fase de grupos",
    how_it_works: "Cómo se juega",
    feat1_title: "ELIGE EL MARCADOR",
    feat1_body: "Pronóstico exacto del marcador antes del kickoff. Tu boleta queda bloqueada cuando rueda el balón.",
    feat1_stake: "+5 PTS EXACTO",
    feat2_title: "ATINA EL RESULTADO",
    feat2_body: "¿Local, visitante o empate? Si aciertas el resultado, igual cobras puntos.",
    feat2_stake: "+2 PTS RESULTADO",
    feat3_title: "GANA EL TROFEO",
    feat3_body: "El top del leaderboard se lleva los premios configurados por el admin: trofeo, camiseta, dinero.",
    feat3_stake: "TOP 3 = PREMIO",
    how_subtitle: "Pronostica cada kickoff. Sube en la tabla. Cobra la boleta.",
    fixtures_total: "Cobertura completa fase de grupos",
    venues: "Sede",
    points_label: "PUNTOS",
    you_chip: "TÚ",
    rank_label: "POS",
    miss: "FALLO",
    exact: "EXACTO",
    outcome: "RESULTADO",
    ft: "FIN",
    locked_chip: "CERRADO",
    pos_short: "POS",
    no_players: "Aún no hay jugadores.",
    bet_pills_exact: "+5 EXACTO",
    bet_pills_result: "+2 RES",
    save_btn_locked: "CERRADO",
    welcome_toast: "¡Bienvenido a Pollagol 2026!",
    saved_toast: "¡Boleta registrada! ⚽",
    enter_scores: "Ingresa ambos marcadores",
    delete_confirm: "¿Eliminar?",
    deleted_toast: "Eliminado",
    prize_added: "Premio agregado",
    prize_updated: "Premio actualizado",
    match_added: "Partido agregado",
    result_saved: "Resultado guardado · puntos otorgados",
    enter_scores_admin: "Ingresa los marcadores",
    subadmins_title: "Sub-administradores",
    subadmins_description:
      "Los sub-administradores pueden capturar resultados, gestionar premios y ver todos los movimientos. No pueden crear ni eliminar otros sub-administradores.",
    create_subadmin: "Crear sub-administrador",
    subadmin_added: "Sub-administrador creado",
    no_subadmins: "Aún no hay sub-administradores.",
    delete_subadmin_confirm: "¿Eliminar al sub-administrador",
    awards_summary: "Resumen de puntos otorgados",
    no_predictions_match: "Nadie pronosticó este partido.",
    close: "Cerrar",
    closes_at: "Cierra a las",
    colombia_time_short: "COL",
    edit_kickoff_title: "Editar hora de partidos",
    edit_kickoff_description:
      "Solo el administrador principal puede modificar la hora de inicio. Los partidos finalizados no se pueden editar.",
    new_kickoff: "Nueva hora",
    no_upcoming_matches: "No hay partidos por jugar.",
    enter_kickoff: "Selecciona una fecha y hora",
    kickoff_updated: "Hora actualizada ⏰",
  },
  en: {
    app_name: "Pollagol 2026",
    tagline: "Predict. Compete. Win.",
    subtagline: "The 2026 World Cup plays here.",
    nav_matches: "Matches",
    nav_leaderboard: "Leaderboard",
    nav_prizes: "Prizes",
    nav_logs: "Activity",
    nav_admin: "Admin",
    login: "Log in",
    register: "Sign up",
    logout: "Log out",
    email: "Email",
    password: "Password",
    name: "Name",
    username: "Username",
    submit: "Submit",
    your_points: "Your points",
    your_rank: "Your rank",
    predict: "Predict",
    save_prediction: "Save prediction",
    prediction_locked: "Closed",
    match_finished: "Finished",
    match_scheduled: "Scheduled",
    live: "Live",
    home: "Home",
    away: "Away",
    stage: "Stage",
    venue: "Venue",
    kickoff: "Kickoff",
    exact_score: "Exact score",
    correct_outcome: "Correct outcome",
    points_rule: "+5 pts exact score · +2 pts outcome",
    rank: "Rank",
    player: "Player",
    points: "Pts",
    no_matches: "No matches yet.",
    no_predictions: "You haven't predicted yet.",
    no_logs: "No activity logged.",
    all_logs: "All activity",
    my_logs: "My activity",
    time: "Time",
    action: "Action",
    details: "Details",
    prizes_title: "Tournament prizes",
    prizes_subtitle: "What you get by owning the World Cup",
    first_place: "1st place",
    second_place: "2nd place",
    third_place: "3rd place",
    admin_panel: "Admin panel",
    add_match: "Add match",
    add_prize: "Add prize",
    set_result: "Set result",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    title: "Title",
    description: "Description",
    position: "Position",
    image_url: "Image URL",
    home_team: "Home team",
    away_team: "Away team",
    home_flag: "Home flag",
    away_flag: "Away flag",
    welcome_back: "Welcome back",
    create_account: "Create your account",
    dont_have_account: "Don't have an account?",
    have_account: "Already have an account?",
    get_started: "Get started",
    view_matches: "View matches",
    total_players: "Players",
    total_matches: "Matches",
    hero_cta: "Join the tournament",
    feature_predict: "Predict every World Cup 2026 scoreline",
    feature_compete: "Climb the global leaderboard",
    feature_win: "Win prizes set by the admin",
    filter_all: "All",
    filter_live: "Live",
    filter_upcoming: "Upcoming",
    filter_finished: "Finished",
    filter_by_group: "Filter by group",
    all_groups: "All groups",
    play_the: "PLAY THE",
    world_cup: "WORLD CUP.",
    own_the_slip: "OWN THE SLIP.",
    open_pool: "Open pool",
    standings: "Standings",
    live_board: "LIVE BOARD",
    payout_structure: "PAYOUT STRUCTURE",
    win_the: "WIN THE",
    trophy: "TROPHY",
    your_slip: "Your slip",
    pick: "Pick",
    balance: "Balance",
    bal_short: "BAL",
    matches_short: "Matches",
    players_short: "Players",
    groups_short: "Groups",
    group_stage_fixtures: "Group-stage fixtures",
    how_it_works: "How it works",
    feat1_title: "PICK THE SCORE",
    feat1_body: "Exact score prediction before kickoff. Your slip locks when the ball rolls.",
    feat1_stake: "+5 PTS EXACT",
    feat2_title: "HIT THE OUTCOME",
    feat2_body: "Home, away or draw? If you nail the outcome you still cash points.",
    feat2_stake: "+2 PTS OUTCOME",
    feat3_title: "WIN THE TROPHY",
    feat3_body: "Top of the leaderboard wins the prizes configured by the admin: trophy, jersey, cash.",
    feat3_stake: "TOP 3 = PAYOUT",
    how_subtitle: "Predict every kickoff. Climb the board. Cash the slip.",
    venues: "Venue",
    points_label: "POINTS",
    you_chip: "YOU",
    rank_label: "RANK",
    miss: "MISS",
    exact: "EXACT",
    outcome: "OUTCOME",
    ft: "FT",
    locked_chip: "LOCKED",
    pos_short: "POS",
    no_players: "No players yet.",
    bet_pills_exact: "+5 EXACT",
    bet_pills_result: "+2 RES",
    save_btn_locked: "LOCK",
    welcome_toast: "Welcome to Pollagol 2026!",
    saved_toast: "Slip registered! ⚽",
    enter_scores: "Enter both scores",
    delete_confirm: "Delete?",
    deleted_toast: "Deleted",
    prize_added: "Prize added",
    prize_updated: "Prize updated",
    match_added: "Match added",
    result_saved: "Result saved · points awarded",
    enter_scores_admin: "Enter the scores",
    subadmins_title: "Sub-administrators",
    subadmins_description:
      "Sub-administrators can enter results, manage prizes and view all activity logs. They cannot create or remove other sub-administrators.",
    create_subadmin: "Create sub-administrator",
    subadmin_added: "Sub-administrator created",
    no_subadmins: "No sub-administrators yet.",
    delete_subadmin_confirm: "Remove sub-administrator",
    awards_summary: "Points awarded summary",
    no_predictions_match: "No one predicted this match.",
    close: "Close",
    closes_at: "Closes at",
    colombia_time_short: "COL",
  },
  pt: {
    app_name: "Pollagol 2026",
    tagline: "Preveja. Compita. Vença.",
    subtagline: "A Copa do Mundo 2026 é jogada aqui.",
    nav_matches: "Jogos",
    nav_leaderboard: "Classificação",
    nav_prizes: "Prêmios",
    nav_logs: "Atividade",
    nav_admin: "Admin",
    login: "Entrar",
    register: "Cadastrar",
    logout: "Sair",
    email: "E-mail",
    password: "Senha",
    name: "Nome",
    username: "Usuário",
    submit: "Enviar",
    your_points: "Seus pontos",
    your_rank: "Sua posição",
    predict: "Prever",
    save_prediction: "Salvar palpite",
    prediction_locked: "Fechado",
    match_finished: "Encerrado",
    match_scheduled: "Agendado",
    live: "Ao vivo",
    home: "Casa",
    away: "Fora",
    stage: "Fase",
    venue: "Estádio",
    kickoff: "Início",
    exact_score: "Placar exato",
    correct_outcome: "Resultado correto",
    points_rule: "+5 pts placar exato · +2 pts resultado",
    rank: "Pos",
    player: "Jogador",
    points: "Pts",
    no_matches: "Sem jogos ainda.",
    no_predictions: "Você ainda não fez palpites.",
    no_logs: "Sem atividades registradas.",
    all_logs: "Toda a atividade",
    my_logs: "Minha atividade",
    time: "Hora",
    action: "Ação",
    details: "Detalhe",
    prizes_title: "Prêmios do torneio",
    prizes_subtitle: "O que você leva dominando a Copa",
    first_place: "1º lugar",
    second_place: "2º lugar",
    third_place: "3º lugar",
    admin_panel: "Painel Admin",
    add_match: "Adicionar jogo",
    add_prize: "Adicionar prêmio",
    set_result: "Definir resultado",
    save: "Salvar",
    cancel: "Cancelar",
    delete: "Excluir",
    edit: "Editar",
    title: "Título",
    description: "Descrição",
    position: "Posição",
    image_url: "URL da imagem",
    home_team: "Time da casa",
    away_team: "Time visitante",
    home_flag: "Bandeira casa",
    away_flag: "Bandeira fora",
    welcome_back: "Bem-vindo de volta",
    create_account: "Crie sua conta",
    dont_have_account: "Não tem uma conta?",
    have_account: "Já tem uma conta?",
    get_started: "Começar",
    view_matches: "Ver jogos",
    total_players: "Jogadores",
    total_matches: "Jogos",
    hero_cta: "Entre no torneio",
    feature_predict: "Preveja cada placar da Copa 2026",
    feature_compete: "Suba na classificação global",
    feature_win: "Ganhe prêmios definidos pelo admin",
    filter_all: "Todos",
    filter_live: "Ao vivo",
    filter_upcoming: "Próximos",
    filter_finished: "Encerrados",
    filter_by_group: "Filtrar por grupo",
    all_groups: "Todos os grupos",
    play_the: "JOGUE A",
    world_cup: "COPA DO MUNDO.",
    own_the_slip: "DOMINE O BILHETE.",
    open_pool: "Bolão aberto",
    standings: "Classificação",
    live_board: "TABELA AO VIVO",
    payout_structure: "ESTRUTURA DE PRÊMIOS",
    win_the: "GANHE O",
    trophy: "TROFÉU",
    your_slip: "Seu bilhete",
    pick: "Palpite",
    balance: "Saldo",
    bal_short: "SAL",
    matches_short: "Jogos",
    players_short: "Jogadores",
    groups_short: "Grupos",
    group_stage_fixtures: "Jogos da fase de grupos",
    how_it_works: "Como jogar",
    feat1_title: "ESCOLHA O PLACAR",
    feat1_body: "Palpite exato do placar antes do kickoff. Seu bilhete trava quando a bola rola.",
    feat1_stake: "+5 PTS EXATO",
    feat2_title: "ACERTE O RESULTADO",
    feat2_body: "Casa, fora ou empate? Se acertar o resultado, ainda assim soma pontos.",
    feat2_stake: "+2 PTS RESULTADO",
    feat3_title: "VENÇA O TROFÉU",
    feat3_body: "O topo da classificação leva os prêmios configurados pelo admin: troféu, camisa, dinheiro.",
    feat3_stake: "TOP 3 = PRÊMIO",
    how_subtitle: "Palpite a cada kickoff. Suba na tabela. Resgate o bilhete.",
    fixtures_total: "Cobertura completa da fase de grupos",
    venues: "Estádio",
    points_label: "PONTOS",
    you_chip: "VOCÊ",
    rank_label: "POS",
    miss: "ERROU",
    exact: "EXATO",
    outcome: "RESULTADO",
    ft: "FIM",
    locked_chip: "TRAVADO",
    pos_short: "POS",
    no_players: "Sem jogadores ainda.",
    bet_pills_exact: "+5 EXATO",
    bet_pills_result: "+2 RES",
    save_btn_locked: "TRAVADO",
    welcome_toast: "Bem-vindo ao Pollagol 2026!",
    saved_toast: "Bilhete registrado! ⚽",
    enter_scores: "Insira ambos os placares",
    delete_confirm: "Excluir?",
    deleted_toast: "Excluído",
    prize_added: "Prêmio adicionado",
    prize_updated: "Prêmio atualizado",
    match_added: "Jogo adicionado",
    result_saved: "Resultado salvo · pontos creditados",
    enter_scores_admin: "Insira os placares",
    subadmins_title: "Subadministradores",
    subadmins_description:
      "Subadministradores podem inserir resultados, gerenciar prêmios e visualizar todos os movimentos. Eles não podem criar nem remover outros subadministradores.",
    create_subadmin: "Criar subadministrador",
    subadmin_added: "Subadministrador criado",
    no_subadmins: "Sem subadministradores ainda.",
    delete_subadmin_confirm: "Remover subadministrador",
    awards_summary: "Resumo de pontos creditados",
    no_predictions_match: "Ninguém palpitou este jogo.",
    close: "Fechar",
    closes_at: "Fecha às",
    colombia_time_short: "COL",
    edit_kickoff_title: "Editar horário dos jogos",
    edit_kickoff_description:
      "Apenas o administrador principal pode alterar o horário de início. Jogos encerrados não podem ser editados.",
    new_kickoff: "Novo horário",
    no_upcoming_matches: "Sem jogos por disputar.",
    enter_kickoff: "Selecione uma data e hora",
    kickoff_updated: "Horário atualizado ⏰",
    edit_kickoff_title: "Editar horário dos jogos",
    edit_kickoff_description:
      "Apenas o administrador principal pode alterar o horário de início. Jogos encerrados não podem ser editados.",
    new_kickoff: "Novo horário",
    no_upcoming_matches: "Sem jogos por disputar.",
    enter_kickoff: "Selecione uma data e hora",
    kickoff_updated: "Horário atualizado ⏰",
  },
};

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("pollagol_lang") || "es");

  useEffect(() => {
    localStorage.setItem("pollagol_lang", lang);
  }, [lang]);

  const t = (key) => (translations[lang] && translations[lang][key]) || key;
  return (
    <I18nContext.Provider value={{ lang, setLang, t, langs: ["es", "en", "pt"] }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used inside I18nProvider");
  return ctx;
};
